<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes">
    <label class="generalLabel" for="mobile">Teléfono</label>
    <input type="text" class="form-control generalInput" id="mobile" maxlength="11"
      v-model.trim.lazy="v$.mobile.$model">
    <div v-if="v$.mobile.$dirty">
      <small class="form-text text-danger" v-if="v$.mobile.required.$invalid">Campo requerido</small>
      <small class="form-text text-danger" v-if="v$.mobile.numeric.$invalid && !v$.mobile.required.$invalid">El
        formato no es correcto</small>
      <small class="form-text text-danger"
        v-if="v$.mobile.minLength.$invalid && !v$.mobile.required.$invalid && !v$.mobile.numeric.$invalid">La
        longitud no es correcta</small>
    </div>
    <button class="btn btn-primary generalPrimaryButton float-right mt-5" data-dismiss="modal" aria-label="Close"
      :disabled="v$.$invalid" @click="modifiedData()">Confirmar</button>
  </Modal>
</template>

<script>

import Modal from '../../Shared/Modal.vue';
import useVuelidate from '@vuelidate/core';
import { numeric, minLength, required } from '@vuelidate/validators'
import axios from 'axios';

export default {
  name: 'EditMobile',
  setup() {
    return { v$: useVuelidate() }
  },
  props: [
    'id',
    'modalTitle',
    'class',
    'list'
  ],
  data() {
    return {
      classes: this.class,
      mobile: '',
    }
  },
  validations() {
    return {
      mobile: {
        required,
        numeric,
        minLength: minLength(9),
      },
    }
  },
  components: {
    Modal,
  },
  methods: {
    modifiedData() {
      let bodyToSend = {
        legalIdentifier: this.list.legalIdentifier,
        mobile: this.mobile,
        email: this.list.email,
        street: this.list.street,
        number: this.list.number,
        postalCode: this.list.postalCode,
        city: this.list.city,
        province: this.list.province,
        surname: this.surname
      }
      axios.patch(`/customer/blacklist-update-mobile/${this.list.mobile}`, bodyToSend)
        .then(() => {
          axios.get(`/customer/blacklist-mobile/${bodyToSend.mobile}`)
          .then((response) => {
            this.$emit("refreshRegisterList", response.data);
          });
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
